import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
export const UPDATE_FILTER_DEBOUNCE_MS = 500;

//Assignee
export const ASSIGNEE_PLACEHOLDER = /*#__PURE__*/_jsx(FormattedMessage, {
  message: "conversations-inbox-ui.thread-search-and-filtering.filter-sidebar.filter-options.assignee.placeholder"
});